import * as polished from 'polished';
import styled from 'styled-components';

export const MatchMarker = styled.div<{ color: string }>`
  position: relative;
  width: 36px;
  height: 36px;
  line-height: 36px;
  border-radius: 50%;
  background: ${(p: any) => p.color};
  border: 2px solid ${(p: any) => polished.lighten(0.2, p.color)};

  > svg {
    //top: 0.125rem;
  }

  > svg * {
    fill: white;
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    bottom: -5px;
    height: 5px;
    width: 3px;
    background: ${(p: any) => p.color};
    left: 50%;
    margin-left: -2px;
    border-bottom-right-radius: 50%;
    border-bottom-left-radius: 50%;
  }
`;

export const DiarizationMarkerLabel = styled.div<{ color: string }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  line-height: 36px;
  border-radius: 50%;
  background: ${(p: any) => p.color};
  border: 2px solid ${(p: any) => polished.lighten(0.2, p.color)};

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: -5px;
    height: 5px;
    width: 3px;
    background: ${(p: any) => p.color};
    left: 15px;
    border-top-right-radius: 50%;
    border-top-left-radius: 50%;
  }
`;
